import { render, staticRenderFns } from "./AttrScore.vue?vue&type=template&id=6896081b&scoped=true&"
import script from "./AttrScore.vue?vue&type=script&lang=js&"
export * from "./AttrScore.vue?vue&type=script&lang=js&"
import style0 from "./AttrScore.vue?vue&type=style&index=0&id=6896081b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6896081b",
  null
  
)

export default component.exports